import { render, staticRenderFns } from "./NewTab.vue?vue&type=template&id=76cc5250"
import script from "./NewTab.vue?vue&type=script&lang=js"
export * from "./NewTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports